export function bindLoadMoreButton() {
  var $loadMoreButton = $('.js-loadmore');

  $loadMoreButton.on('click', function (e) {
    e.preventDefault();
    var $currentButton = $(this);
    var nextPageStart = Number($currentButton.data('nextpagestart'));
    var totalItems = Number($currentButton.data('totalitems'));

    if (nextPageStart <= totalItems) {
      $.ajax({
        url: $currentButton.attr('href'),
        beforeSend:function(){
          $currentButton.text("Loading...");
        }
      })
      .done(function (response) {
        $currentButton.closest(".js-resource_items").find(".js-resource_item:last").after(response).show().fadeIn("slow");
        $currentButton.parent().remove();
        $('html').trigger('ako.loaded.more');
      });
    }
  });
}

$(function() {
  bindLoadMoreButton();
  $('html').on('ako.loaded.more', function () {
    bindLoadMoreButton();
  });
});



// WEBPACK FOOTER //
// ./src/js/SeeMore.js